<script>
  import { MediaSlider, Faq, PartnerForm, Steps, Button } from '$client';
  import { Link, phonePrettify, phonePurify, store, imgSrc } from '$client';
  import { onMount } from 'svelte';
  const { city } = store;

  export let data;
  $: promotion = data.promotion;
  $: promotions = data.promotions;

  onMount(() => {
    const phone = promotion.phone;
    if (!phone) return () => {};
    const nodes = [...document.querySelectorAll('a[href^=tel]')];
    nodes.forEach(e => {
      e.setAttribute('href', `tel:${phonePurify(phone)}`);
      e.innerText = phonePrettify(phone);
    });

    return () => {
      const phone = $city.phone;
      nodes.forEach(e => {
        e.setAttribute('href', `tel:${phonePurify(phone)}`);
        e.innerText = phonePrettify(phone);
      });
    };
  });
</script>

<section id="main">
  <section class="top-banner container">
    <div>
      <img
        src={imgSrc(promotion.pageImg.data.attributes.url)}
        alt={promotion.pageImg.data.attributes.alternativeText} />
      <h1 class="h1">{promotion.header}</h1>
      <span class="promotion-buttons">
        {#each promotion.button as button}
          <Button action={button.href} title={button.header} />
        {/each}
      </span>
    </div>
  </section>

  <section class="container">
    <h2 class="h2">{promotion.about.header}</h2>
    <p class="margin-block custom-page">{@html promotion.about.data}</p>
  </section>

  <Steps data={promotion.steps} />

  <Faq data={promotion.faq.data.attributes} type="integrated" />

  <PartnerForm data={promotion.form.data.attributes} img={promotion.formImg.data.attributes} />

  {#if promotion.news.data.data.length > 0}
    <MediaSlider data={promotion.news.data.data} header={promotion.news.header} type="white" />
  {/if}

  {#if promotion.partners.data.length > 0}
    <section id="other-promotions" class="container">
      <h2 class="h2 margin-bottom">{promotion.partnersHeader}</h2>
      <div>
        {#each promotion.partners.data as { attributes: img }}
          {#if img.caption}
            <a target="_blank" rel="nofollow" href={img.caption}>
              <img loading="lazy" src={imgSrc(img.url)} alt={img.alternativeText} height="224" width="290" />
            </a>
          {:else}
            <img loading="lazy" src={imgSrc(img.url)} alt={img.alternativeText} height="224" width="290" />
          {/if}
        {/each}
      </div>
    </section>
  {/if}

  {#if promotions.length > 0}
    <footer id="other-partners" class="container">
      <nav>
        <h2 class="h2 margin-bottom">Другие акции</h2>
        <ul>
          {#each promotions as elem}
            <li>
              <Link href="/partnery/{elem.attributes.url}">
                <img
                  loading="lazy"
                  src={imgSrc(elem.attributes.cardImg.data.attributes.url)}
                  alt={elem.attributes.cardImg.data.attributes.alternativeText}
                  height="224"
                  width="290" />
                {elem.attributes.header}</Link>
            </li>
          {/each}
        </ul>
      </nav>
    </footer>
  {/if}
</section>

<style lang="scss">
  .promotion-buttons {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 24px;

    @media only screen and (max-width: 767.98px) {
      align-items: center;
      justify-content: center;
    }
  }

  #main {
    display: flex;
    flex-direction: column;
    gap: 60px;
    margin-top: 40px;
    margin-bottom: 40px;

    :global(.steps) {
      background-color: #f6f7f8;
      background-image: url('https://admin.uberi.pro/uploads/fon_6f0d7f8289.svg');
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 110%;
      padding-block: 100px;
    }

    h1 {
      z-index: 2;
      width: 70%;
      color: #fff;
      font-weight: 800;
      font-family: Vela-Sans, sans-serif;

      @media only screen and (max-width: 767.98px) {
        width: 100%;
      }
    }

    :global(.slider-container) {
      padding-block: 0 !important;
    }

    h2 {
      font-weight: 800;
      font-family: Vela Sans;
      text-align: start;
    }

    .top-banner {
      width: 100%;

      @media only screen and (max-width: 575.98px) {
        padding-inline: 0 !important;
      }

      div {
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 50px;
        align-items: flex-start;
        justify-content: center;
        width: 100%;
        min-height: 350px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        border-radius: 15px;
        padding-block: 60px;
        padding-inline: 40px;

        @media only screen and (max-width: 767.98px) {
          min-height: 300px;
        }

        @media only screen and (max-width: 575.98px) {
          align-items: center;
          background-image: none !important;
          border-radius: 0;
          padding-inline: 0;
          padding-block: 80px;
        }

        img {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 15px;
          aspect-ratio: 21 / 9;

          @media only screen and (max-width: 575.98px) {
            border-radius: 0;
          }
        }

        &::after {
          position: absolute;
          z-index: 1;
          display: block;
          width: 100%;
          height: 100%;
          background-color: rgb(0 0 0 / 20%);
          border-radius: 15px;
          content: '';
          inset: 0;

          @media only screen and (max-width: 575.98px) {
            border-radius: 0;
          }
        }

        :global(a) {
          z-index: 2;
        }
      }
    }

    > section:nth-child(2) {
      display: flex;
      flex-direction: column;
      gap: 15px;
      align-items: flex-start;

      p {
        color: rgb(44 51 60 / 100%);
        font-size: 18px;
        font-family: Roboto, sans-serif;
        line-height: 25px;

        @media only screen and (max-width: 767.98px) {
          font-size: 16px;
        }
      }
    }
  }

  #other-promotions {
    width: 100%;

    div {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 30px;
      align-items: center;
      justify-content: center;
      width: 100%;

      @media only screen and (max-width: 991.98px) {
        grid-template-columns: repeat(3, 1fr);
      }

      @media only screen and (max-width: 767.98px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media only screen and (max-width: 480px) {
        display: inline-flex;
        grid-template-columns: none;
        align-items: flex-start;
        justify-content: space-between;
        overflow: auto hidden;
      }

      img {
        width: 100%;
        object-fit: contain;
        border-radius: 15px;
        filter: grayscale(1);
        transition: filter 0.3s;

        @media only screen and (max-width: 1199.98px) {
          min-width: 200px;
          height: 134px;
        }
      }

      :global(a) {
        display: flex;
        flex-direction: column;
        gap: 15px;
        align-items: flex-start;
        color: rgb(44 51 60 / 100%);
        font-weight: 600;
        font-size: 16px;
        font-family:
          Vela Sans,
          sans-serif;

        &:hover {
          :global(> img) {
            filter: grayscale(0);
          }
        }
      }
    }
  }

  #other-partners {
    width: 100%;

    ul {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 30px;
      align-items: center;
      justify-content: center;
      width: 100%;

      @media only screen and (max-width: 991.98px) {
        grid-template-columns: repeat(3, 1fr);
      }

      @media only screen and (max-width: 767.98px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media only screen and (max-width: 480px) {
        display: inline-flex;
        grid-template-columns: none;
        align-items: flex-start;
        justify-content: space-between;
        overflow: auto hidden;
      }

      img {
        width: 100%;
        object-fit: cover;
        border-radius: 15px;
        filter: grayscale(1);
        transition: filter 0.3s;

        @media only screen and (max-width: 1199.98px) {
          min-width: 200px;
          height: 134px;
        }
      }

      :global(a) {
        display: flex;
        flex-direction: column;
        gap: 15px;
        align-items: flex-start;
        color: rgb(44 51 60 / 100%);
        font-weight: 600;
        font-size: 16px;
        font-family:
          Vela Sans,
          sans-serif;

        &:hover {
          :global(> img) {
            filter: grayscale(0);
          }
        }
      }
    }
  }
</style>
